(function () {
  'use strict';

  var module = angular.module('uwAgenda.global');
  module.directive('sharedAgendasDropdown', [
    'SharedAgendaService',
    'SharedAgendaBroadcast',
    '$state',
    '$uibModal',
    'ViewsService',
    SharedAgendasDropdownFn,
  ]);

  /* directive for shared agendas dropdown in header */
  function SharedAgendasDropdownFn(
    SharedAgendaService,
    SharedAgendaBroadcast,
    $state,
    $uibModal,
    ViewsService
  ) {
    var directive = {
      link: link,
      restrict: 'E',
      templateUrl:
        '/app/global/templates/rf-global-shared-agendas-dropdown.template.html',
    };
    return directive;

    function link(scope, element) {
      // agendas to display
      scope.service = SharedAgendaService.data;
      var noRefreshOnAgendaChange = [
        'Home.Agenda_Day',
        'Home.Agenda_Week',
        'Home.FirstFreeAppointments',
        'Home.AgendaLists.Unconfirmed'
      ]

      activate();

      function activate() {
        // current selected shared-agenda
        scope.owner = SharedAgendaService.currentUser();

        listen();
      }

      function listen() {
        // listen on changed client
        var listener = scope.$on(
          SharedAgendaBroadcast.AgendaOwnerLoaded,
          function () {
            updateUI(SharedAgendaService.data.currentAgenda);
          }
        );

        var lUi = scope.$on(SharedAgendaBroadcast.UpdateUI, function () {
          updateUI(SharedAgendaService.data.currentAgenda);
        });

        var currentOwnerChangedListener = scope.$on(
          SharedAgendaBroadcast.AgendaOwnerChanged,
          function () {
            scope.owner = SharedAgendaService.currentUser();        

            // check if we need to refresh
            if (noRefreshOnAgendaChange.indexOf($state.current.name) === -1) {
                $state.go($state.current, {}, { reload: $state.current.name });
            }    
          }
        );

        // on destroy
        scope.$on('$destroy', function () {
          listener();
          lUi();
          currentOwnerChangedListener();
          listener = null;
          lUi = null;
          currentOwnerChangedListener = null;
        });
      }

      // select
      function select(agenda) {
        // is user allowed to change/select another user ?
        if (scope.service.selectable === false) {
          return;
        }

        var modal = $uibModal.open({
          backdrop: 'static',
          keyboard: false,
          animation: true,
          templateUrl: '/app/global/components/switch-agenda-modal/switch-agenda-modal.html',
          controller: 'SwitchAgendaModalController',
          controllerAs: 'vm',
          size: 'xs',
          resolve: {
            agendaCaption: function () {
              return agenda.owner.company || agenda.owner.caption;
            }
          }
        });

        modal.result.then(function () {
          SharedAgendaService.setCurrentUser(agenda.owner);

          // look up view for the agenda owner
          var newAgendaOwnerView = ViewsService.getViewForUser(agenda.owner.id);
          if (!newAgendaOwnerView) {
            showCreateViewModal(agenda.owner);
          } else {
            ViewsService.setCurrentView(newAgendaOwnerView);
          }        
        });
      }
      
      function showCreateViewModal(agendaOwner) {
        var modal = $uibModal.open({
          backdrop: 'static',
          keyboard: false,
          animation: true,
          templateUrl: '/app/global/components/create-view-modal/create-view-modal.html',
          controller: 'CreateViewModalController',
          controllerAs: 'vm',
          size: 'xs',
          resolve: {
            agendaCaption: function () {
              return agendaOwner.company || agendaOwner.caption;
            }
          }
        });

        modal.result.then(function () {
          // create a new view + switch to it
          var newView = {
            id: 0,
            name: agendaOwner.company || agendaOwner.caption,
            ownerId: SharedAgendaService.getLoggedInUserData().id,
            forOperators: false,
            sortOrder: 0,
            viewUsers: [{
              userId: agendaOwner.id,
              userCaption: agendaOwner.company || agendaOwner.caption,
              showInAgendaDayView: true,
              showInAgendaWeekView: true,
              showInNewAppointments: true,
              showInFreeAppointments: true,
              showDayTasks: true
          }]
        };

        ViewsService.createView(newView)
                    .then(function(view) {
                        ViewsService.setCurrentView(view);
                        ViewsService.getViewsForOwner(SharedAgendaService.getLoggedInUserData().id);
                        $state.go('Home.Agenda_Day', {}, { reload: $state.current.name });
                    });
        });
      }

      function updateUI(agenda) {
        scope.current = agenda;
      }

      /* select user */
      scope.select = select;
    }
  }
})();
